export enum GenericRequestMessageType {
    TEXT = 'TEXT',
    INTENT = 'INTENT',
    APPLICATION_EVENT = 'APPLICATION_EVENT',
    LAUNCH = 'LAUNCH',
    DEEPLINK = 'DEEPLINK',
}

export type GenericRequestMessage = {
    type: GenericRequestMessageType;
    body: any;
    locale?: string;
    application?: any;
    device?: any;
    state?: any;
};

export type GenericResponseMessage = {
    output: any[];
    state?: any;
};
